import PropTypes from 'prop-types';
import { MUTATION_TYPES } from '../Observe/constants';

export const COLLAPSIBLE_OBSERVER_OPTIONS = {
  childList: true,
  subtree: true,
};

export const COLLAPSIBLE_TYPES = {
  children: PropTypes.node,
  className: PropTypes.string,
  collapsibleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  contentClassName: PropTypes.string,
  expanded: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  observerOptions: PropTypes.shape(MUTATION_TYPES),
};

export const COLLAPSIBLE_DEFAULTS = {
  children: null,
  className: '',
  contentClassName: '',
  observerOptions: COLLAPSIBLE_OBSERVER_OPTIONS,
};
